import React, {useEffect, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";

import {AppContext} from "../../HomePage";
import {SearchDiagnosticsService} from "../../service/SearchDiagnosticsService";

const service = new SearchDiagnosticsService();

// Only `top_broken_hosts` is offered. Those are the hosts whose failures a spider fix can
// change; the rest of the campaign's drops are the customer's own configuration, and
// re-fetching them would quietly undo a deliberate exclusion. The backend enforces the
// same rule - this list is the polite half of it, not the guard.
//
// The endpoint also refuses an empty `hosts` list (it would mean "retry the whole
// campaign", a far more expensive job than this button offers), so the Run button stays
// disabled whenever nothing is ticked rather than letting the server reject the call.
const RetryFailedUrlsDialog = ({visible, onHide, data, campaignId}) => {

    const {t, toast, setError} = React.useContext(AppContext);
    const label = (key) => t(`search_diagnostics.${key}`);

    const broken = data?.top_broken_hosts || [];

    const [selected, setSelected] = useState([]);
    const [running, setRunning] = useState(false);

    // Preselect every broken host: they are what an admin opened this dialog for.
    useEffect(() => {
        if (visible) {
            setSelected(broken.map(entry => entry.host));
        }
    }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

    const toggle = (host) => setSelected(selected.includes(host)
        ? selected.filter(item => item !== host)
        : [...selected, host]);

    const outcomeName = (outcome) => t(`search_diagnostics.outcome_${outcome}`);

    const fail = (error) => {
        setError(error);
        setError(null);
        setRunning(false);
    };

    const run = () => {
        if (selected.length === 0 || running) return;
        setRunning(true);
        service.startRetry(campaignId, selected)
            .then(() => {
                setRunning(false);
                onHide();
                toast.current.show({
                    severity: 'success',
                    summary: t('search_diagnostics.retry_started'),
                });
            })
            .catch(fail);
    };

    return <Dialog header={label('retry_failed')} visible={visible} onHide={onHide}
                   style={{width: '40rem', maxWidth: '95vw'}}>
        <p style={{color: 'var(--text-color-secondary)', marginTop: 0}}>{label('retry_hint')}</p>

        {broken.map(entry => <div key={entry.host} style={{marginBottom: '.35em'}}>
            <Checkbox inputId={`retry-${entry.host}`} checked={selected.includes(entry.host)}
                      onChange={() => toggle(entry.host)}/>
            <label htmlFor={`retry-${entry.host}`} style={{marginLeft: '.5em', cursor: 'pointer'}}>
                {entry.host}
                <span style={{color: 'var(--text-color-secondary)', marginLeft: '.5em'}}>
                    {outcomeName(entry.reason)} · {entry.products} {label('products_column')}
                </span>
            </label>
        </div>)}

        <div style={{marginTop: '1em', textAlign: 'right'}}>
            <Button label={label('retry_failed')} icon="pi pi-replay"
                    onClick={run} disabled={selected.length === 0 || running} loading={running}/>
        </div>
    </Dialog>;
};

export default RetryFailedUrlsDialog;
